import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendMessage } from 'store/chat/services/sendMessage.service';

export const sendChatMessageThunk = createAsyncThunk(
  'chat/sendMessage',
  async ({ message, attachment }, { getState }) => {
    const state = getState();
    const thread = state.chatSlice.thread;
    const threadId = thread.isSubthread
      ? 'subthread'
      : thread.threadId || thread.id;

    const sentMessage = await sendMessage(
      threadId,
      { ...message, hasAttachment: Boolean(attachment) },
      thread.target,
      thread.type
    );
    return sentMessage;
  }
);
